import { DateUtils } from '@grandvisionhq/utils';
import { OPENING_HOURS_DAYS, OpenClosedStatus } from '../types/index.js';

const getDayName = (index)=>OPENING_HOURS_DAYS[index]
;
const getHoursAndMinutes = (time)=>time.split(time.indexOf('.') > -1 ? '.' : ':').map((t)=>parseInt(t)
    )
;
const getSpecialOpeningHoursForDate = (specialOpeningHours, date)=>{
    return specialOpeningHours === null || specialOpeningHours === void 0 ? void 0 : specialOpeningHours.find(({ dateOpenClosed  })=>new Date(dateOpenClosed).getDate() === date.getDate() && new Date(dateOpenClosed).getMonth() === date.getMonth()
    );
};
/**
 * @param day A number 0-6 mapping to the day
 *  of the week starting from 0 which equals Sunday
 * */ const getRegularOpeningHoursForDay = (openingHours, day)=>{
    if (day < 0 || day > 6) {
        throw new Error('parameter day should be a number equal to 0 through 6');
    }
    return openingHours[getDayName(day)];
};
const getDateFromTime = (time)=>{
    const [hours, minutes] = getHoursAndMinutes(time);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date;
};
const isOpen = (hours)=>{
    const now = new Date();
    return hours === null || hours === void 0 ? void 0 : hours.some(({ open , close  })=>{
        const openDate = getDateFromTime(open);
        const closeDate = getDateFromTime(close);
        return now.getTime() >= openDate.getTime() && now.getTime() < closeDate.getTime();
    });
};
const isClosingSoon = (hours)=>{
    const now = new Date();
    return hours === null || hours === void 0 ? void 0 : hours.some(({ close  })=>{
        const closeDate = getDateFromTime(close);
        const diff = Math.floor((closeDate.getTime() - now.getTime()) / 1000 / 60);
        return diff > 0 && diff < 60;
    });
};
const isClosed = (hours)=>{
    const now = new Date();
    return hours === null || hours === void 0 ? void 0 : hours.every(({ close  })=>{
        const closeDate = getDateFromTime(close);
        return now.getTime() > closeDate.getTime();
    });
};
const getNormalOpenCloseStatusForDay = (openingHours, day)=>{
    const openingHoursForDay = getRegularOpeningHoursForDay(openingHours, day);
    const open = isOpen(openingHoursForDay);
    const closingSoon = isClosingSoon(openingHoursForDay);
    const closed = isClosed(openingHoursForDay);
    if (closed) {
        return OpenClosedStatus.Closed;
    }
    if (closingSoon) {
        return OpenClosedStatus.Closing;
    }
    return open ? OpenClosedStatus.Open : OpenClosedStatus.Closed;
};
const getOpenCloseStatus = (openingHours, specialOpeningHours)=>{
    const now = new Date();
    const openingHoursToday = getRegularOpeningHoursForDay(openingHours, now.getDay());
    const specialOpeningHoursToday = getSpecialOpeningHoursForDate(specialOpeningHours, now);
    let open, closingSoon, closed;
    if (specialOpeningHoursToday) {
        open = specialOpeningHoursToday.openClosed === 'OPEN' && isOpen(specialOpeningHoursToday.openClosedTime);
        closingSoon = isClosingSoon(specialOpeningHoursToday.openClosedTime);
        closed = !open || isClosed(specialOpeningHoursToday.openClosedTime);
    } else {
        open = isOpen(openingHoursToday);
        closingSoon = isClosingSoon(openingHoursToday);
        closed = isClosed(openingHoursToday);
    }
    if (closed) {
        return OpenClosedStatus.Closed;
    }
    if (closingSoon) {
        return OpenClosedStatus.Closing;
    }
    return open ? OpenClosedStatus.Open : OpenClosedStatus.Closed;
};
const getOpenCloseIndication = (openingHours, specialOpeningHours, timeFormatter)=>{
    const today = new Date();
    const tomorrow = DateUtils.shiftDate(today, 'day', 1);
    const status = getOpenCloseStatus(openingHours, specialOpeningHours);
    const specialOpeningHoursToday = getSpecialOpeningHoursForDate(specialOpeningHours, today);
    const specialOpeningHoursTomorrow = getSpecialOpeningHoursForDate(specialOpeningHours, tomorrow);
    const regularOpeningHoursToday = getRegularOpeningHoursForDay(openingHours, today.getDay());
    const regularOpeningHoursTomorrow = getRegularOpeningHoursForDay(openingHours, tomorrow.getDay());
    if (status === OpenClosedStatus.Open || status === OpenClosedStatus.Closing) {
        var ref;
        return {
            hours: (ref = (specialOpeningHoursToday === null || specialOpeningHoursToday === void 0 ? void 0 : specialOpeningHoursToday.openClosedTime) || regularOpeningHoursToday) === null || ref === void 0 ? void 0 : ref.map(({ open , close  })=>[
                    timeFormatter(getDateFromTime(open)),
                    timeFormatter(getDateFromTime(close)), 
                ]
            )
        };
    }
    if (status === OpenClosedStatus.Closed) {
        let nextHours;
        if ((specialOpeningHoursToday === null || specialOpeningHoursToday === void 0 ? void 0 : specialOpeningHoursToday.openClosed) === OpenClosedStatus.Open || (regularOpeningHoursToday === null || regularOpeningHoursToday === void 0 ? void 0 : regularOpeningHoursToday.length)) {
            var ref1;
            if (specialOpeningHoursToday === null || specialOpeningHoursToday === void 0 ? void 0 : (ref1 = specialOpeningHoursToday.openClosedTime) === null || ref1 === void 0 ? void 0 : ref1.length) {
                var ref2;
                nextHours = specialOpeningHoursToday === null || specialOpeningHoursToday === void 0 ? void 0 : (ref2 = specialOpeningHoursToday.openClosedTime) === null || ref2 === void 0 ? void 0 : ref2.find(({ open  })=>getDateFromTime(open).getTime() > today.getTime()
                );
            } else if (regularOpeningHoursToday.length) {
                nextHours = regularOpeningHoursToday.find(({ open  })=>getDateFromTime(open).getTime() > today.getTime()
                );
            }
            if (nextHours) {
                return {
                    opensAt: 'TODAY',
                    hours: [
                        [
                            timeFormatter(getDateFromTime(nextHours.open))
                        ]
                    ]
                };
            }
        }
        if ((specialOpeningHoursTomorrow === null || specialOpeningHoursTomorrow === void 0 ? void 0 : specialOpeningHoursTomorrow.openClosed) === OpenClosedStatus.Open || (regularOpeningHoursTomorrow === null || regularOpeningHoursTomorrow === void 0 ? void 0 : regularOpeningHoursTomorrow.length)) {
            var ref3;
            if (specialOpeningHoursTomorrow === null || specialOpeningHoursTomorrow === void 0 ? void 0 : (ref3 = specialOpeningHoursTomorrow.openClosedTime) === null || ref3 === void 0 ? void 0 : ref3.length) {
                nextHours = specialOpeningHoursTomorrow.openClosedTime[0];
            } else if ((specialOpeningHoursTomorrow === null || specialOpeningHoursTomorrow === void 0 ? void 0 : specialOpeningHoursTomorrow.openClosed) !== OpenClosedStatus.Closed && regularOpeningHoursTomorrow.length) {
                nextHours = regularOpeningHoursTomorrow[0];
            }
            if (nextHours) {
                return {
                    opensAt: 'TOMORROW',
                    hours: [
                        [
                            timeFormatter(getDateFromTime(nextHours.open))
                        ]
                    ]
                };
            }
        }
    }
    return {
        hours: []
    };
};

export { getNormalOpenCloseStatusForDay, getOpenCloseIndication, getOpenCloseStatus };
//# sourceMappingURL=location-utils.js.map
